<template>
  <div id="app" v-if="$store.getters.getCountryList.length>0">
      <Header v-if="isAuthActive"/>

      <el-container style="min-height: 100vh;">
        
        <el-main>
          <router-view style="top: 10px; position: relative;"/>          
         </el-main> 

        <br><br><br><br><br>
        <el-footer>
          <span v-if="getCurrentHostName.includes('cloud.easytailor') || getCurrentHostName.includes('localhost')" style="font-size: 10px;" v-html="'2017-'+new Date().getFullYear()+' &copy; Easy Tailor App LLP, All Rights Reserved.'">
          </span>
          <span v-else style="font-size: 10px;" v-html="'Hosted at '+getCurrentHostName">
          </span>
        </el-footer>      
      </el-container>
      <el-backtop>
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
          <span style="font-weight: bold;"><i class="el-icon-arrow-up"></i> UP</span>
        </div>
       
      </el-backtop>
       
  </div>
  <div id="app" v-else style="width: 100%; text-align: center;">
    <h1>Loading...</h1>
  </div>
</template>

<script>
//import { ipcRenderer  } from "electron";
import Header from './components/Header.vue'
import { isMobile } from 'mobile-device-detect';

export default {
  components: {Header},
  data() {
    return {
    }
  },
  computed: {
    getCurrentHostName() {
      return window.location.hostname
    },
    isCustomDomainMatching() {
      if(this.getCurrentHostName.includes(this.$store.getters.getCustomDomainName)) {
        return true
      }
      return false
    }, 
    isAuthActive() {
      return this.$store.getters.isAuthenticated
    },
    getWindowObject() {
      return this.win
    },
    getAccessToken() {
      return localStorage.getItem('accessToken')        
    },
    getExistingDeviceToken() {
        return localStorage.getItem("device_token")
    },
    isMobileDevice() {
        return isMobile
    }
  },
  methods: {
      setDefaultProperties() {

        let deviceToken = ''
        if(this.$route.query.redirect) {
          deviceToken = this.$route.query.redirect.replace('/?device_token=', '')
        } else if(this.$route.query.device_token) {
          deviceToken = this.$route.query.device_token
        }
        
        if(deviceToken.length > 5) {
            this.$store.commit('setDeviceToken', deviceToken)
        } else if(this.isMobileDevice) {
            //alert(JSON.stringify(this.$route.query)+'Failed to recognise the device, this may result in abrupt printing service')
        }

        if(this.getAccessToken !== null && this.getAccessToken.length > 0) {
          this.$store.dispatch('checkAccessToken', {navigate: false, device_token: deviceToken})
        } else {
          this.$store.dispatch('loadCountryList')
          this.$store.dispatch('loadShipmentPartner')
        }

      }
  },
  mounted() {
      setTimeout(() => {
        this.setDefaultProperties()
      }, 2000);
      window.scroll(0, 0)
    
  }
}


</script>


<style>
body {
  font-size: 13px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: #383838;
  -moz-osx-font-smoothing: #383838;
  text-align: center;
  color: #383838;  
}

#app {
  width: 100wh;  
}

.rowFontSize {
  font-size: 13px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue